<script setup lang="ts">
import { computed } from 'vue'

import type { CheckboxRootProps } from '@fondof-ui/components/checkbox/types'
import {
  CheckboxRoot,
  type CheckboxRootEmits,
  useForwardPropsEmits,
} from 'radix-vue'

const props = defineProps<CheckboxRootProps>()

const emits = defineEmits<CheckboxRootEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <CheckboxRoot
    v-bind="forwarded"
    :class="props.class"
  >
    <slot />
  </CheckboxRoot>
</template>
